<div class="gray-font-color font-family display-text">
  <div class="header-navigation-back">
    <span class="title">Drivers License Scan</span>
    @if (mobile) {
      <button  mat-icon-button (click)="onOpenActionSheet()">
        <mat-icon aria-hidden="false" aria-label="Identity actions">more_horiz</mat-icon>
      </button>
    }
  </div>
  @if (status) {
    <app-status-banner [status]="status" class="padding-bottom-xlg"> </app-status-banner>
  }
  @if (!mobile) {
    <div class="txt">
      @if (!mobile) {
        <div class="scan">
          <p>Scan one of the QR code below to make the switch</p>
        </div>
      }
      @if (!mobile) {
        <div class="qr-div margin-bottom-xlg"  fxLayoutGap="180px" alt="Responsive">
          <div >
            <img [src]="iOSAppQR" class="ios-qrcode-img" alt="Responsive image" />
            <img [src]="appStoreIcon" class="app-store" alt="Responsive image" />
          </div>
          <div>
            <img [src]="qrImg" class="qrcode-img" alt="Responsive image" />
          </div>
        </div>
      }
    </div>
  }
  @if (mobile) {
    <div class="txt">
      <div class="html">
        <div >
          <img src="assets/images/driver-license-vector.png" class="license-vector" />
        </div>
        <div fxFlex="7" class="header-text">
          {{ title }}
        </div>
        <div fxFlex="43" class="body-text">
          {{ html }}
        </div>
      </div>
    </div>
  }
  <app-actions [actions]="actions"></app-actions>
</div>
